// extracted by mini-css-extract-plugin
module.exports = {"container":"lista_container_2BNqR","status":"lista_status_35fAC","countdown":"lista_countdown_1wjfr"};